/* import __COLOCATED_TEMPLATE__ from './address.hbs'; */
import Component from '@ember/component';

export default class EditBusinessComponent extends Component {
  tagName = '';
}
